import { MissionId } from '@wwf/sdk';

export const getLinkToMission = (
    missionId: MissionId | undefined | null,
    type: 'show' | 'show_notes' | 'edit' = 'show'
) => {
    if (!missionId) return '';
    switch (type) {
        case 'show':
            return `/mission/${missionId}/show`;
        case 'show_notes':
            return `/mission/${missionId}/show/notes`;
        case 'edit':
            return `/mission/${missionId}/edit`;
    }
};
